/* @flow */

import * as React from 'react';

import type { ReadOnlyKeyValuePair } from '../jsHelpers/types';

export type NOTIFICATION_MESSAGE = React.Node;
export type NOTIFICATION_SETTINGS = ReadOnlyKeyValuePair<boolean | string | number>;

export type NOTIFICATION = {
  ariaLabel?: string,
  message: NOTIFICATION_MESSAGE,
  settings?: NOTIFICATION_SETTINGS,
};

// Cannot be converted to enum because strings come from Toastify
export const TOAST = Object.freeze({
  Error: 'error',
  Info: 'info',
  Success: 'success',
  Warning: 'warning',
});
export type NOTIFICATION_TYPE = 'info' | 'success' | 'warning' | 'error';
